import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { Typography } from "../../../Typography/index.js";
import { Box } from "../../../Box/index.js";
const HelperText = (t0)=>{
    const $ = c(2);
    const { text } = t0;
    let t1;
    if ($[0] !== text) {
        t1 = /*#__PURE__*/ jsx(Box, {
            pt: "4",
            children: /*#__PURE__*/ jsx(Typography, {
                variant: "caption",
                color: "text.light.tertirary",
                children: text
            })
        });
        $[0] = text;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
export { HelperText };
